import React, { useState } from "react";
import SVG from "react-inlinesvg";

export const ESVG = ({
                       className = "",
                       path,
                       svgClassName = "",
                       size = "24", // Default size in pixels
                       ...props
                     }) => {
  const [isLoading, setIsLoading] = useState(true);

  // Helper to construct absolute URL
  const getAssetUrl = (relativePath) => {
    const cleanPath = relativePath.startsWith('/') ? relativePath.substring(1) : relativePath;
    const baseUrl = process.env.NODE_ENV === 'development' ? '/' : '/';
    return `${baseUrl}${cleanPath}`;
  };

  // Bootstrap-friendly sizing
  const getSizeClass = (size) => {
    if (typeof size === 'string' && size.includes('px')) return '';
    const sizeMap = {
      '16': 'icon-sm',
      '20': 'icon-md',
      '24': 'icon-lg',
      '32': 'icon-xl',
      '48': 'icon-xxl',
      'sm': 'icon-sm',
      'md': 'icon-md',
      'lg': 'icon-lg',
      'xl': 'icon-xl',
      'xxl': 'icon-xxl'
    };
    return sizeMap[size] || 'icon-md';
  };

  const getInlineStyles = () => {
    if (typeof size === 'string' && size.includes('px')) {
      return { width: size, height: size, minWidth: size, minHeight: size };
    }
    if (typeof size === 'number') {
      return {
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`
      };
    }
    return {};
  };

  const containerClasses = [
    'svg-icon',
    'd-inline-flex',
    'align-items-center',
    'justify-content-center',
    getSizeClass(size),
    className
  ].filter(Boolean).join(' ');

  const svgClasses = ['w-100', 'h-100', svgClassName].filter(Boolean).join(' ');
  const assetUrl = getAssetUrl(path);

  return (
      <span
          className={containerClasses}
          style={getInlineStyles()}
          {...props}
      >
      {isLoading && (
          <div
              className="placeholder-glow bg-secondary rounded"
              style={{ width: '100%', height: '100%', minHeight: '16px' }}
          />
      )}
        <SVG
            src={assetUrl}
            className={svgClasses}
            onLoad={() => setIsLoading(false)}
            onError={(e) => {
              setIsLoading(false);
              console.error("SVG failed to load:", assetUrl, e);
            }}
            preProcessor={(code) => code.replace(/fill="none"/g, '')} // optional cleanup
        />
    </span>
  );
};

export const BSIcon = ({
                         path,
                         size = "20",
                         className = "",
                         variant = "primary"
                       }) => {
  const variantClass = variant ? `text-${variant}` : '';
  return (
      <ESVG
          path={path}
          size={size}
          className={`${variantClass} ${className}`}
      />
  );
};

export default ESVG;
